module.exports = __webpack_public_path__ + "static/media/american-express-dark.270d6764.svg";